import React, {useEffect, useState} from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import API_Service from '../../Services/API_Service';
import {empty, req_cust_area, req_cust_chain, req_cust_type} from '../../Helper/Constants';
import {useMediaQuery, useTheme} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	dlg: {
		minWidth: 300,
		margin: 5,
		marginLeft: 20,
		marginRight: 20
	},
	total: {
		float: 'left',
		color: 'grey',
		fontWeight: 'bold'
	},
	viewInRowSpace: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between'
	}
}));

export default function AddAreaType({open, onClose, language, onSnack, axiosConfig}) {
	const classes = useStyles();

	const [custAreaCode, setCustAreaCode] = useState(empty);
	const [custAreaName, setCustAreaName] = useState(empty);

	useEffect(() => {
	}, [open]);

	const closeRemove = (data) => {
		const payload = Array.isArray(data) ? data[0] : data;
		setCustAreaCode(empty);
		setCustAreaName(empty);
		onClose(payload);
	}

	const addCustArea = () => {
		let formData = new FormData();
		formData.append('code', custAreaCode);
		formData.append('name', custAreaName);

		if (custAreaName === empty || custAreaCode === empty) {
			onSnack('Insert Area Code and Area Name', 'warning');
		} else {
			API_Service.post(req_cust_area, formData, axiosConfig).then(({data}) => {
				const {result, extraData} = data;
				if (result) {
					const payload = Array.isArray(extraData) ? extraData[0] : extraData;
					const fallback = {
						area_code: custAreaCode,
						area_name: custAreaName,
						code: custAreaCode,
						name: custAreaName,
					};
					closeRemove(payload || fallback);
					onSnack(language.insert_success);
				} else {
					onSnack(language.insert_fail, 'warning');
				}
			});
		}
	}

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Dialog fullScreen={fullScreen} onClose={() => closeRemove()} aria-labelledby="simple-dialog-title" open={open}>
			<DialogTitle id="simple-dialog-title">
				{language.new_cust_area}
			</DialogTitle>
			<div style={{width: 600, padding: theme.spacing(2)}}>
				<div className={classes.viewInRowSpace}>
					<TextField
						id="input-area-code"
						style={{width: '48%', height: 50}}
						inputProps={{maxLength: 10, pattern: "[a-z]{1,15}"}}
						label={language.cust_area_code}
						value={custAreaCode}
						onChange={(e) => setCustAreaCode(e.target.value)}
					/>
					<TextField
						id="input-area-name"
						style={{width: '48%', height: 50}}
						label={language.cust_area_name}
						value={custAreaName}
						onChange={(e) => setCustAreaName(e.target.value)}
					/>
				</div>
				<div style={{height: 20}}/>
				<div style={{display: "flex"}}>
					<Button
						style={{marginLeft: 'auto'}}
						variant="outlined"
						disabled={custAreaCode === empty || custAreaName === empty}
						onClick={() => {
							addCustArea()
						}}
						color={'primary'}>
						{language.add}
					</Button>
				</div>
				<div style={{height: 20}}/>
			</div>
		</Dialog>
	)
}

